import CloseIcon from 'svg/CloseIcon';
import Button from 'components/Button';
import Modal from 'components/modals/Modal';
import { ManageFollowCoachModalProps } from './types';

const ManageFollowCoachModal: React.FC<ManageFollowCoachModalProps> = ({
  isOpen,
  handleClose,
  isFollowPrompt,
  loading,
  handleChangeCoachFollowing,
}) => {
  let title, desc, choiceBtnText;

  switch (isFollowPrompt) {
    case true:
      title = 'Confirm follow coach';
      desc =
        'By following this coach, you will be able to book them directly from the home page. The coach can also invite you to future lessons and clinics. ';
      choiceBtnText = 'Follow';

      break;

    case false:
      title = 'Conirm unfollow coach';
      desc =
        "By unfollowing this coach, you will no longer see them on your home page. The coach won't be able to invite you to lessons or clinics.";
      choiceBtnText = 'Unfollow';
      break;

    default:
      break;
  }

  return (
    <Modal isOpen={isOpen} handleClose={handleClose}>
      <div className="px-ds-xl pt-ds-xl">
        <div className="mb-8 flex items-center justify-between">
          <h3 className="typography-product-heading-compact-desktop">{title}</h3>
          <CloseIcon className="h-5 w-5 cursor-pointer" onClick={() => handleClose()} />
        </div>
        <p className="typography-product-body mb-6 text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
          {desc}
        </p>
      </div>
      <div className="flex flex-row-reverse gap-ds-lg border-t p-ds-xl">
        <Button
          disabled={loading}
          variant="brand"
          size="lg"
          onClick={() => {
            handleClose();
            handleChangeCoachFollowing(isFollowPrompt);
          }}
        >
          {choiceBtnText}
        </Button>
        <Button variant="secondary" size="lg" onClick={() => handleClose()}>
          Cancel
        </Button>
      </div>
    </Modal>
  );
};

export default ManageFollowCoachModal;
